import { DepartmentNames } from "./models";

/** How many LPNs one shift's node asks for. The rest of the node is RNs. */
export const LPN_PER_SHIFT = 1;

/** Staffing-page number rules for a few demo departments. */
export interface DemoStaffingRules {
	/**
	 * Take each shift's required RN/LPN count from the node (the shift's staffNo) and split it
	 * across the rooms, instead of using the ratio ladder. `null` keeps the ladder.
	 */
	nodeSplit: { lpnPerShift: number } | null;
	/** On past days that have punches, count and show the punched staff instead of the schedule. */
	pastDaysCountPunches: boolean;
}

// Ids must match exactly (no prefix or case matching). A Map, so ids like "constructor" never
// match an object prototype key.
const DEMO_STAFFING_RULES: ReadonlyMap<string, DemoStaffingRules> = new Map([
	[DepartmentNames.BayviewGeneralHospital, { nodeSplit: { lpnPerShift: LPN_PER_SHIFT }, pastDaysCountPunches: true }],
]);

/** The department's demo rules, or `undefined` for every other department. */
export const getDemoStaffingRules = (departmentId: string): DemoStaffingRules | undefined => DEMO_STAFFING_RULES.get(departmentId);

/** True when past days with punches should count punched staff for this department. */
export const countsPunchesOnPastDays = (departmentId: string): boolean => getDemoStaffingRules(departmentId)?.pastDaysCountPunches === true;
